import React, { useEffect, useLayoutEffect, useMemo } from 'react';
import { StyleSheet } from 'react-native';
import Animated, { useAnimatedScrollHandler, useSharedValue } from 'react-native-reanimated';
import { AppView, Indicator, NavigationHeader, rem, SCROLL_INDICATOR_INSETS } from 'design-system';
import { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import StatusBar from 'design-system/StatusBar';
import { getSearchResults } from 'features/invest/actions';
import ReadyMadeFund from 'features/invest/components/ReadyMadeFund';
import { selectSecclGiaReadyMadeFunds } from 'features/invest/reducers/selectors';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import useColors from 'hooks/useColors';
import Amplitude from 'utils/amplitude';
import LeaveOnboardingButton from 'features/wealth/components/LeaveOnboardingButton';
import { OnboardingFlow } from 'utils/types/navigation';
import { isWeb } from '../../../constants';
const strings = {
    title: 'Let’s find the right fund for you',
    subtitle: 'Pick a fund that matches your comfort level and financial goals',
};
const StartInvestReadyMadeFundsScreen = ({ route, navigation }) => {
    // useReturnIfHasTraded();
    const colors = useColors();
    const scrollY = useSharedValue(0);
    const mountedOnAnotherScreen = route.params?.mountedOnAnotherScreen;
    const hasInvestOnboardingState = useAppSelector((state) => !!state.invest.onboarding);
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(getSearchResults('seccl'));
        if (hasInvestOnboardingState && !mountedOnAnotherScreen) {
            Amplitude.logEvent('Select Fund Screen');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { paddingHorizontalStyle } = useAppFrameDimensions(mountedOnAnotherScreen || isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', HEIGHT_PLUS_PADDING, paddingHorizontalStyle, styles.flex);
    const assetIds = useAppSelector(selectSecclGiaReadyMadeFunds);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary]);
    const outputColors = useMemo(() => [colors.background.dark, colors.cards.onDark], [colors.background.dark, colors.cards.onDark]);
    const scrollHandler = useAnimatedScrollHandler((event) => {
        scrollY.value = event.contentOffset.y;
    });
    return (<AppView withFrame={false}>
      <StatusBar barStyle="dark-content"/>
      <NavigationHeader scrollY={scrollY} hideTitleOnScroll regularTitleHeight outputColors={outputColors} isInTab={!!mountedOnAnotherScreen} leftContent={mountedOnAnotherScreen ? <LeaveOnboardingButton flow={OnboardingFlow.Invest}/> : undefined} title=""/>
      <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} keyboardShouldPersistTaps="handled" contentContainerStyle={contentContainerStyle} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}>
        <ScreenInfoHeader title={strings.title} subTitle={strings.subtitle} style={styles.header}/>
        {assetIds.length > 0 ? (assetIds.map((assetId) => <ReadyMadeFund key={assetId} assetId={assetId}/>)) : (<Indicator dark/>)}
      </Animated.ScrollView>
    </AppView>);
};
const styles = StyleSheet.create({
    flex: {
        flex: 1,
    },
    header: {
        paddingBottom: rem(16),
    },
});
export default StartInvestReadyMadeFundsScreen;
